import { createSlice } from '@reduxjs/toolkit';

const entityState = () => ({ data: [], loading: false, error: null });

const initialState = {
  materials: entityState(),
  manufacturers: entityState(),
  inventory: entityState(),
  glassBeads: entityState(),
};

const slice = createSlice({
  name: 'suppliesArchive',
  initialState,
  reducers: {
    fetchStarted(state, { payload: entity }) {
      state[entity].loading = true;
      state[entity].error = null;
    },
    fetchSucceeded(state, { payload: { entity, data } }) {
      state[entity].data = data;
      state[entity].loading = false;
    },
    fetchFailed(state, { payload: { entity, error } }) {
      state[entity].loading = false;
      state[entity].error = error;
    },
    errorCleared(state, { payload: entity }) {
      state[entity].error = null;
    },
    reset: () => initialState,
  },
});

export const suppliesArchiveActions = slice.actions;

export default slice.reducer;
